/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Change password
 * @export
 * @interface CompanyChangePassword
 */
export interface CompanyChangePassword {
    /**
     * 
     * @type {string}
     * @memberof CompanyChangePassword
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyChangePassword
     */
    password?: string;
}

export function CompanyChangePasswordFromJSON(json: any): CompanyChangePassword {
    return CompanyChangePasswordFromJSONTyped(json, false);
}

export function CompanyChangePasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyChangePassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldPassword': !exists(json, 'old_password') ? undefined : json['old_password'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function CompanyChangePasswordToJSON(value?: CompanyChangePassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'old_password': value.oldPassword,
        'password': value.password,
    };
}


